(function () {
  'use strict';

  var root = document.getElementById('lbt-treasure-event');
  if (!root) return;

  var STORAGE_KEY = 'lbt_treasure_dismissed';
  var startDate = new Date(root.getAttribute('data-start'));
  var endDate = new Date(root.getAttribute('data-end'));
  var delay = parseFloat(root.getAttribute('data-delay')) || 0;
  var once = root.getAttribute('data-once') === 'true';
  var now = new Date();

  // Bail if dates are invalid, or we are outside the event window
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return;
  if (now < startDate || now >= endDate) return;

  // Respect "don't show again" flag
  if (once && localStorage.getItem(STORAGE_KEY) === 'true') return;

  var timerEl = root.querySelector('[data-lbt-timer]');
  var hoursEl = root.querySelector('[data-lbt-hours]');
  var minutesEl = root.querySelector('[data-lbt-minutes]');
  var secondsEl = root.querySelector('[data-lbt-seconds]');
  var canvas = root.querySelector('[data-lbt-canvas]');
  var copyBtn = root.querySelector('[data-lbt-copy]');
  var codeEl = root.querySelector('[data-lbt-code]');
  var closeEls = root.querySelectorAll('[data-lbt-close]');

  function dismiss() {
    root.classList.remove('lbt-show');
    setTimeout(function () {
      root.classList.remove('lbt-active');
    }, 350);
    if (once) {
      localStorage.setItem(STORAGE_KEY, 'true');
    }
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', dismiss);
  });

  // ---- Countdown ----
  var countdownInterval;
  function tick() {
    var diff = endDate.getTime() - Date.now();
    if (diff <= 0) {
      clearInterval(countdownInterval);
      dismiss();
      return;
    }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    hoursEl.textContent = String(h).padStart(2, '0');
    minutesEl.textContent = String(m).padStart(2, '0');
    secondsEl.textContent = String(s).padStart(2, '0');
  }

  // ---- Scratch canvas ----
  function initScratchCard() {
    var ctx = canvas.getContext('2d');
    var wrap = canvas.parentElement;

    function resize() {
      var rect = wrap.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
      paintOverlay();
    }

    function paintOverlay() {
      var w = canvas.width;
      var h = canvas.height;
      // Canvas gradients cannot read CSS vars directly, resolve manually
      var accent = getComputedStyle(root).getPropertyValue('--lbt-accent').trim() || '#C98C92';
      var accentDark = getComputedStyle(root).getPropertyValue('--lbt-accent-dark').trim() || '#8C5B60';
      var grad = ctx.createLinearGradient(0, 0, w, h);
      grad.addColorStop(0, accent);
      grad.addColorStop(1, accentDark);
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);

      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.font = '600 12px ' + (getComputedStyle(document.body).fontFamily || 'sans-serif');
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH TO REVEAL', w / 2, h / 2);
    }

    var isDrawing = false;
    var scratchedPixels = 0;
    var totalPixels = 0;
    var revealed = false;
    var CHECK_THRESHOLD = 0.45;

    function getPos(evt) {
      var rect = canvas.getBoundingClientRect();
      var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
      var clientY = evt.touches ? evt.touches[0].clientY : evt.clientY;
      return { x: clientX - rect.left, y: clientY - rect.top };
    }

    function scratchAt(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 22, 0, Math.PI * 2);
      ctx.fill();
    }

    function checkRevealProgress() {
      if (revealed) return;
      var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var cleared = 0;
      var sampleStep = 4 * 8; // sample every 8th pixel for performance
      var samples = 0;
      for (var i = 3; i < imageData.length; i += sampleStep) {
        samples++;
        if (imageData[i] === 0) cleared++;
      }
      var ratio = cleared / samples;
      if (ratio >= CHECK_THRESHOLD) {
        revealComplete();
      }
    }

    function revealComplete() {
      revealed = true;
      canvas.classList.add('lbt-hidden');
    }

    function handleStart(evt) {
      isDrawing = true;
      var pos = getPos(evt);
      scratchAt(pos.x, pos.y);
    }
    function handleMove(evt) {
      if (!isDrawing) return;
      evt.preventDefault();
      var pos = getPos(evt);
      scratchAt(pos.x, pos.y);
    }
    function handleEnd() {
      if (!isDrawing) return;
      isDrawing = false;
      checkRevealProgress();
    }

    canvas.addEventListener('mousedown', handleStart);
    canvas.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleEnd);

    canvas.addEventListener('touchstart', handleStart, { passive: true });
    canvas.addEventListener('touchmove', handleMove, { passive: false });
    canvas.addEventListener('touchend', handleEnd);

    window.addEventListener('resize', resize);
    resize();
  }

  // ---- Copy button ----
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = 'Copied!';
          copyBtn.classList.add('lbt-copied');
          setTimeout(function () {
            copyBtn.textContent = 'Copy Code';
            copyBtn.classList.remove('lbt-copied');
          }, 1800);
        });
      }
      if (once) {
        localStorage.setItem(STORAGE_KEY, 'true');
      }
    });
  }

  // ---- Init on delay ----
  setTimeout(function () {
    root.classList.add('lbt-active');
    requestAnimationFrame(function () {
      root.classList.add('lbt-show');
    });
    try {
      initScratchCard();
    } catch (err) {
      console.error('LBT Treasure Event: scratch card failed to init', err);
    }
    tick();
    countdownInterval = setInterval(tick, 1000);
  }, delay * 1000);
})();